/* Seal'd Kitchen Co. — cart cross-sell popup.
   When one product is added to cart, offer the other with its pack options. */
(function () {
  'use strict';

  var PAIR = {
    'the-seald-press-2-in-1-bag-sealer-cutter': {
      handle: 'the-seald-mini-clip-on-pocket-bag-sealer',
      eyebrow: 'Wait — complete the set',
      title: 'Add the Seal\u2019d Mini for the drawer?',
      note: '\uD83D\uDE9A Your order already ships FREE with any pack.'
    },
    'the-seald-mini-clip-on-pocket-bag-sealer': {
      handle: 'the-seald-press-2-in-1-bag-sealer-cutter',
      eyebrow: 'Wait — complete the set',
      title: 'Add the full-size Seal\u2019d Press?',
      note: '\uD83D\uDE9A Orders $35+ ship FREE in the US.'
    }
  };

  var suppress = false;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function shown(handle) {
    try { return sessionStorage.getItem('sealed_xsell_' + handle) === '1'; } catch (e) { return false; }
  }
  function markShown(handle) {
    try { sessionStorage.setItem('sealed_xsell_' + handle, '1'); } catch (e) {}
  }

  function refreshCartUI() {
    try {
      var drawer = document.querySelector('cart-drawer');
      var sections = '/?sections=cart-drawer,cart-icon-bubble';
      fetch(sections)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data['cart-icon-bubble']) {
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble) {
              var t = document.createElement('div');
              t.innerHTML = data['cart-icon-bubble'];
              var inner = t.querySelector('.shopify-section') || t;
              bubble.innerHTML = inner.innerHTML;
            }
          }
          if (drawer && data['cart-drawer']) {
            var tmp = document.createElement('div');
            tmp.innerHTML = data['cart-drawer'];
            var newDrawer = tmp.querySelector('cart-drawer');
            if (newDrawer) {
              drawer.innerHTML = newDrawer.innerHTML;
              drawer.classList.remove('is-empty');
            }
          }
        })
        .catch(function () {});
    } catch (e) {}
  }

  function buildModal(product, cfg) {
    var overlay = document.createElement('div');
    overlay.className = 'sealed-xsell-overlay';
    var img = (product.featured_image || (product.images && product.images[0]) || '');
    var modal = document.createElement('div');
    modal.className = 'sealed-xsell-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');

    var variants = product.variants.filter(function (v) { return v.available !== false; });
    var preselect = Math.min(1, variants.length - 1);

    var optionsHtml = variants.map(function (v, i) {
      var compare = v.compare_at_price && v.compare_at_price > v.price
        ? '<span class="sealed-xsell-option-compare">' + money(v.compare_at_price) + '</span>'
        : '';
      return '<label class="sealed-xsell-option' + (i === preselect ? ' is-selected' : '') + '">' +
        '<input type="radio" name="sealed-xsell-variant" value="' + v.id + '"' + (i === preselect ? ' checked' : '') + '>' +
        '<span class="sealed-xsell-option-price">' + money(v.price) + '</span>' + compare +
        '<span>' + v.title.replace(/\s\u2014\s\$[\d.]+/g, '') + '</span>' +
        '</label>';
    }).join('');

    modal.innerHTML =
      '<button class="sealed-xsell-close" aria-label="Close">\u00D7</button>' +
      '<p class="sealed-xsell-eyebrow">' + cfg.eyebrow + '</p>' +
      '<h3 class="sealed-xsell-title">' + cfg.title + '</h3>' +
      '<div class="sealed-xsell-product">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '<div class="sealed-xsell-product-name">' + product.title + '</div>' +
      '</div>' +
      optionsHtml +
      '<button class="sealed-xsell-add">Add to my order</button>' +
      '<button class="sealed-xsell-skip">No thanks, my snacks can share</button>' +
      '<p class="sealed-xsell-shipnote">' + cfg.note + '</p>';

    overlay.appendChild(modal);

    function close() {
      overlay.remove();
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    modal.querySelector('.sealed-xsell-close').addEventListener('click', close);
    modal.querySelector('.sealed-xsell-skip').addEventListener('click', close);
    document.addEventListener('keydown', onKey);

    modal.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'sealed-xsell-variant') {
        modal.querySelectorAll('.sealed-xsell-option').forEach(function (el) { el.classList.remove('is-selected'); });
        e.target.closest('.sealed-xsell-option').classList.add('is-selected');
      }
    });

    modal.querySelector('.sealed-xsell-add').addEventListener('click', function () {
      var sel = modal.querySelector('input[name="sealed-xsell-variant"]:checked');
      if (!sel) return;
      var btn = this;
      btn.disabled = true;
      btn.textContent = 'Adding\u2026';
      suppress = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(sel.value, 10), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = '\u2713 Added!';
          refreshCartUI();
          setTimeout(close, 700);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Add to my order';
        })
        .finally(function () { setTimeout(function () { suppress = false; }, 500); });
    });

    document.body.appendChild(overlay);
  }

  function maybeShow(addedHandle) {
    if (suppress) return;
    var cfg = PAIR[addedHandle];
    if (!cfg || shown(cfg.handle)) return;
    markShown(cfg.handle);
    fetch('/products/' + cfg.handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        setTimeout(function () { buildModal(product, cfg); }, 650);
      })
      .catch(function () {});
  }

  function handleAddResponse(json) {
    try {
      var item = null;
      if (json && json.items && json.items.length) item = json.items[0];
      else if (json && json.handle) item = json;
      if (item && item.handle) maybeShow(item.handle);
    } catch (e) {}
  }

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isAdd = url.indexOf('/cart/add') !== -1;
    var p = origFetch.apply(this, arguments);
    if (isAdd) {
      p.then(function (res) {
        if (res && res.ok) {
          res.clone().json().then(handleAddResponse).catch(function () {});
        }
      }).catch(function () {});
    }
    return p;
  };

  /* Fallback for XHR-based adds */
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (url && String(url).indexOf('/cart/add') !== -1) {
      this.addEventListener('load', function () {
        try { handleAddResponse(JSON.parse(this.responseText)); } catch (e) {}
      });
    }
    return origOpen.apply(this, arguments);
  };
})();
